import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { MongoDbAtlasCopySource } from 'app/model/pipeline/copysource/mongo-db-atlas.copysource';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { toCursorMethodClass, toCursorMethodObject } from 'app/model/adapters/linkedservices/cursor-method.util';
import { isLogicAppExpression, isExpressionObject } from 'app/shared/utils/expression.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MongoDbAtlasCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        batchSize: '*',
        filter: '*',
        cursorMethods: '*'
    }
})
export class MongoDbAtlasCopySourceAdapter extends CopySourceAdapter<MongoDbAtlasCopySource, Model.MongoDbAtlasSource> {
    protected override async _toResource(copySource: MongoDbAtlasCopySource): Promise<Model.MongoDbAtlasSource> {
        const result: Model.MongoDbAtlasSource = this.getCommonCopySourceProperties(
            copySource,
            Metamodel.modelFor(MongoDbAtlasCopySource).name
        );
        result.batchSize = ValueAdapter.toResource(copySource, MongoDbAtlasCopySource.BATCH_SIZE);
        result.filter = ValueAdapter.toResource(copySource, MongoDbAtlasCopySource.FILTER);
        const cursorMethodsValue =
            MongoDbAtlasCopySource.CURSORMETHODS != null
                ? MongoDbAtlasCopySource.CURSORMETHODS.templateValue(copySource)
                : undefined;
        result.cursorMethods =
            cursorMethodsValue != null
                ? ValueAdapter.toResource(copySource, MongoDbAtlasCopySource.CURSORMETHODS)
                : toCursorMethodObject(copySource.cursorMethods);
        return result;
    }

    protected override async _toModel(
        resource: Model.MongoDbAtlasSource,
        copyActivity: CopyActivity
    ): Promise<MongoDbAtlasCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            MongoDbAtlasCopySource.MODEL,
            resource,
            copyActivity
        ) as MongoDbAtlasCopySource;
        ValueAdapter.toModel(result, MongoDbAtlasCopySource.BATCH_SIZE, resource.batchSize);
        ValueAdapter.toModel(result, MongoDbAtlasCopySource.FILTER, resource.filter);
        if (
            resource.cursorMethods != null &&
            (isExpressionObject(resource.cursorMethods) || isLogicAppExpression(resource.cursorMethods))
        ) {
            ValueAdapter.toModel(result, MongoDbAtlasCopySource.CURSORMETHODS, resource.cursorMethods);
        } else {
            result.cursorMethods = toCursorMethodClass(resource.cursorMethods, result);
        }
        return result;
    }
}
